import "./Toolbar.scss"

import React, { FunctionComponent } from "react"
import cn from "classnames"

type ToolbarTheme = "default" | "light"

export type ToolbarProps = {
    theme?: ToolbarTheme
    condensed?: boolean
}

const Toolbar: FunctionComponent<React.PropsWithChildren<ToolbarProps>> = ({
    theme = "default",
    condensed,
    children
}) => {
    return (
        <div className={cn(
            `toolbar toolbar--theme-${theme}`,
            { "toolbar--condensed": condensed },
        )}>
            {children}
        </div>
    )
}

export default Toolbar
